<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-08 20:14:35
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-05 20:21:01
 * @Description: 动态内容
 -->

<template>
  <div class="party-content-wrapper">
    <h3 class="title">{{ title }}</h3>
    <div v-html="htmlBody" class="party-content"></div>
  </div>
</template>
<script>
export default {
  name: 'party-content-wrapper',
  data() {
    return {
      htmlBody: '',
      title: ''
    };
  },
  created() {
    this.requestContent();
  },
  methods: {
    async requestContent() {
      const res = await this.$http.post('cg/commonRequest', {
        method: 'pinfo.party.building.detail',
        // method: 'content.trend.detail',
        token: '',
        // terminal: 4,
        // label: ''
        articleid: this.$route.params.id
      });
      if (res.code === 200) {
        this.title = res.data.title;
        this.htmlBody = res.data.body;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.party-content-wrapper {
  .title {
    text-align: center;
    font-size: 0.28rem;
    line-height: 0.32rem;
    color: #666;
    margin: 0.2rem 0 0;
  }
  .party-content {
    font-size: 0.24rem;
    min-height: 6rem;
    padding: 0.2rem;
  }
}
</style>
